const UPDATES = [
  { id: 1, time: '10分钟前', title: '某顶流男星被拍到与神秘女子同回酒店，粉丝已炸锅', tag: '明星八卦', hot: true },
  { id: 2, time: '28分钟前', title: '知名美妆博主被曝产品成分造假，品牌方紧急回应', tag: '网红翻车', hot: true },
  { id: 3, time: '1小时前', title: '热门综艺导演被曝与选手有不正当关系', tag: '综艺内幕', hot: true },
  { id: 4, time: '2小时前', title: '直播平台头部主播涉嫌偷税漏税被调查', tag: '直播塌房', hot: false },
  { id: 5, time: '3小时前', title: '娱乐圈资深经纪人爆料某女星片场耍大牌内幕', tag: '深度揭秘', hot: false },
  { id: 6, time: '4小时前', title: '体育明星婚变传闻升级，双方律师已介入', tag: '体育八卦', hot: false },
  { id: 7, time: '5小时前', title: '电竞冠军选手被曝私下代打，俱乐部回应中', tag: '电竞吃瓜', hot: false },
  { id: 8, time: '6小时前', title: '海外某好莱坞明星离婚案最新进展曝光', tag: '海外爆料', hot: false },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
          <div>
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
              实时更新
            </span>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950">
              最新快讯
            </h2>
          </div>
          <span className="text-xs text-foreground-400 flex items-center gap-1 whitespace-nowrap">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            实时更新中
          </span>
        </div>

        <div className="max-w-3xl mx-auto space-y-1">
          {UPDATES.map((item) => (
            <div
              key={item.id}
              className="flex items-start gap-4 p-3.5 rounded-xl hover:bg-background-50 transition-colors duration-200 cursor-pointer group"
            >
              <div className="relative mt-1">
                <div className="w-2.5 h-2.5 rounded-full bg-primary-400 flex-shrink-0 ring-4 ring-primary-100"></div>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-1">
                  {item.hot && (
                    <span className="text-[10px] px-1.5 py-0.5 rounded bg-primary-100 text-primary-700 font-semibold whitespace-nowrap">
                      HOT
                    </span>
                  )}
                  <span className="text-[11px] px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{item.time}</span>
                </div>
                <h3 className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors leading-relaxed">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}